export default __webpack_public_path__ + "static/media/visa.9d1df8b3.svg";